import React, { useState } from 'react';
import { Eye, FileText, FileSpreadsheet, Image, Printer, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';
import { toast } from 'sonner';
import { REPORT_API } from './useReport';

export const downloadReport = async (report, format, params, printWindow = null) => {
  try {
    const response = await api.get(`${REPORT_API}/${report}/${format}`, { params: { ...params, offset: undefined, limit: undefined }, responseType: 'blob', timeout: 180000 });
    const url = URL.createObjectURL(response.data);
    if (printWindow) {
      printWindow.document.title = 'Imprimir relatório';
      let requested = false;
      const print = () => {
        if (requested || printWindow.closed) return;
        requested = true;
        printWindow.focus();
        printWindow.print();
      };
      // O leitor nativo abre o PDF completo, sem depender do load de um iframe/plugin.
      printWindow.addEventListener('load', () => setTimeout(print, 500), { once: true });
      printWindow.location.href = url;
      setTimeout(print, 1800);
    } else {
      const filename = response.headers['content-disposition']?.match(/filename="([^"]+)"/)?.[1] || `${report}.${response.data.type.includes('zip') ? 'zip' : format}`;
      const anchor = document.createElement('a'); anchor.href = url; anchor.download = filename; anchor.click();
      if (response.data.type.includes('zip')) toast.success('Todas as páginas foram exportadas no arquivo ZIP.');
    }
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (error) {
    if (printWindow) printWindow.close();
    let detail = error.userMessage;
    try { detail = JSON.parse(await error.response.data.text()).detail || detail; } catch (_) { /* resposta não JSON */ }
    throw new Error(detail || 'Não foi possível gerar o arquivo.');
  }
};

export const ExportActions = ({ report, params, ready, loading, preview, refresh }) => {
  const [busy, setBusy] = useState('');
  const exportFile = async format => {
    let printWindow;
    if (format === 'print') {
      printWindow = window.open('', '_blank');
      if (!printWindow) { toast.error('Não foi possível abrir a janela de impressão.'); return; }
    }
    setBusy(format);
    try { await downloadReport(report, format === 'print' ? 'pdf' : format, params, printWindow); }
    catch (error) { toast.error(error.message); }
    finally { setBusy(''); }
  };
  return <div className="report-actions" data-testid="report-export-actions">
    <Button onClick={refresh} disabled={!ready || loading || !!busy} className="report-primary" data-testid="btn-carregar-preview"><Eye className="h-4 w-4 mr-2" />Visualizar</Button>
    <div className="flex flex-wrap gap-2">
      {[["pdf", "PDF", FileText], ["xlsx", "Excel", FileSpreadsheet], ["png", "PNG", Image], ["jpg", "JPG", Image], ["print", "Imprimir", Printer]].map(([id, label, Icon]) => <Button key={id} variant="outline" size="sm" onClick={() => exportFile(id)} disabled={!ready || loading || !preview?.rows.length || !!busy} data-testid={`btn-export-${id}`}>
        {busy === id ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Icon className={`h-4 w-4 mr-2 ${id === 'pdf' ? 'text-rose-700' : id === 'xlsx' ? 'text-emerald-700' : ''}`} />}{label}
      </Button>)}
    </div>
  </div>;
};